<template>
    <div v-if="isVisible" v-bind:class="componentStyles">
        <a v-if="linkOnly" :href="searchPageUri" v-bind:class="linkStyles"><slot>{{ linkText }}</slot></a>
        <b-row v-else>
            <b-col>
                <a :href="searchPageUri" v-bind:class="linkStyles"><slot>{{ linkText }}</slot></a>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                searchPageUri: null
            };
        },
        props: {
            linkText: {
                type: String,
                default: 'Back to search'
            },
           storageKey: {
                type: String,
                default: '_aha.last-search'
            },
            linkClass: {
                type: String,
                default: ''
            },
            linkOnly: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            isVisible: function() {
                return !!this.searchPageUri;
            }
        },
        mounted() {
            var store = localStorage.getItem(this.storageKey);
            if(!store) return;
            var lastSearch = JSON.parse(store);
            if(lastSearch && window.location.href.indexOf(lastSearch.id) >= 0){
                this.searchPageUri = lastSearch.baseURI;
            }

            this.componentStyles = 'container container-fluid back-to-search-container';
            if(this.linkOnly)
                this.componentStyles = '';

            this.linkStyles = 'c-cta c-cta--icon h-theme--red c-cta--arrow-reverse c-cta--back-to-search';
            if(this.linkClass !== '' && this.linkClass !== undefined)
                this.linkStyles = this.linkStyles + " " + this.linkClass;
        }
    }
</script>

<style scoped>
    .c-cta--arrow-reverse:before {
        content: "<";
        width: 15px;
    }

    .c-cta--arrow-reverse {
        padding: 1.875rem 0;
    }

    .c-cta--arrow-reverse:hover:before {
        text-decoration: none;
    }
</style>

<style>
    .back-to-search-container + .c-hero-full {
        margin-top: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/app/components/aha-back-to-search.vue